<template>
  <el-container class="page">
    <AppSidebar :active-menu.sync="activeMenu" />

    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i class="el-icon-setting"></i>
          <span class="header-title">系统设置</span>
        </div>

        <div class="header-right">
          <el-button icon="el-icon-s-custom" @click="onSwitchAccount">切换账号</el-button>
          <el-button v-if="false" type="primary" icon="el-icon-document-checked" @click="onSaveAll">保存设置</el-button>
        </div>
      </el-header>

      <el-main class="main">
        <!-- 1. 数据库连接设置（隐藏） -->
        <el-card v-if="false" shadow="never" class="card">
          <div slot="header" class="card-header">
            <span>数据库连接设置</span>
          </div>

          <el-form :model="db" label-width="120px" size="small">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="数据库主机" required>
                  <el-input v-model="db.host" placeholder="例如：localhost" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="数据库端口" required>
                  <el-input v-model="db.port" placeholder="例如：3306" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="数据库名称" required>
                  <el-input v-model="db.database" placeholder="请输入数据库名称" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="用户名" required>
                  <el-input v-model="db.username" placeholder="请输入数据库用户名" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="密码" required>
                  <el-input v-model="db.password" placeholder="请输入数据库密码" show-password />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="字符集">
                  <el-select v-model="db.charset" placeholder="请选择" style="width: 100%">
                    <el-option label="UTF-8 (utf8mb4)" value="utf8mb4" />
                    <el-option label="UTF-8 (utf8)" value="utf8" />
                    <el-option label="GBK" value="gbk" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="card-actions">
              <el-button icon="el-icon-refresh" @click="onLoadDbDefault">重置默认</el-button>
              <el-button type="warning" icon="el-icon-s-promotion" @click="onTestDb">测试连接</el-button>
              <el-button type="success" icon="el-icon-document-checked" @click="onSaveDb">保存数据库配置</el-button>
            </div>
          </el-form>
        </el-card>

        <!-- 2. 管理员账户设置 -->
        <el-card shadow="never" class="card">
          <div slot="header" class="card-header">
            <span>管理员账户设置</span>
          </div>

          <el-form :model="admin" label-width="120px" size="small">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="当前登录账号">
                  <el-input v-model="admin.username" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="登录时间">
                  <el-input v-model="admin.loginAt" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户角色">
                  <el-input v-model="admin.role" disabled />
                </el-form-item>
              </el-col>
            </el-row>
          <el-row v-if="admin.role === '票务核销员'" :gutter="16" style="margin-top:8px">
            <el-col :span="8">
              <el-form-item label="核销地点（观礼平台）">
                <el-input v-model="admin.platform" disabled />
              </el-form-item>
            </el-col>
          </el-row>
            <el-row v-if="admin.role === '分销商'" :gutter="16" style="margin-top:8px">
              <el-col :span="8">
                <el-form-item label="供应商单位名称">
                  <el-input v-model="admin.supplier" disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <div class="sub-section-title">修改登录密码</div>

            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="当前密码" required>
                  <el-input v-model="pwd.old" placeholder="请输入当前密码" show-password />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="新密码" required>
                  <el-input v-model="pwd.new" placeholder="请输入新密码" show-password />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="确认新密码" required>
                  <el-input v-model="pwd.confirm" placeholder="请再次输入新密码" show-password />
                </el-form-item>
              </el-col>
            </el-row>

            <div class="card-actions right">
              <el-button type="danger" icon="el-icon-key" @click="onChangePassword">修改密码</el-button>
            </div>

            <template v-if="isSuperAdmin">
              <div class="sub-section-title">管理员账号管理</div>

              <el-row :gutter="16" style="margin-bottom: 10px">
                <el-col :span="8">
                  <el-form-item label="新增账号">
                    <el-input v-model="addAdmin.username" placeholder="请输入登录账号" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="初始密码">
                    <el-input v-model="addAdmin.password" placeholder="请输入初始密码" show-password />
                  </el-form-item>
                </el-col>
              <el-col :span="8">
                  <el-form-item label="用户角色">
                    <el-select v-model="addAdmin.role" placeholder="选择用户角色" style="width: 100%">
                      <el-option label="超级管理员" value="超级管理员" />
                      <el-option label="游客录入员" value="游客录入员" />
                      <el-option label="票务核销员" value="票务核销员" />
                      <el-option label="分销商" value="分销商" />
                      <el-option label="财务人员" value="财务人员" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="addAdmin.role === '分销商'">
                  <el-form-item label="供应商单位名称">
                    <el-input v-model="addAdmin.supplier" placeholder="请输入供应商单位名称" />
                  </el-form-item>
                </el-col>
              <el-col :span="8" v-if="addAdmin.role === '票务核销员'">
                <el-form-item label="核销地点（观礼平台）">
                  <el-select v-model="addAdmin.platform" placeholder="请选择核销地点" style="width: 100%">
                    <el-option
                      v-for="(p, idx) in platformOptions"
                      :key="'platform-' + idx"
                      :label="p"
                      :value="p"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="addAdmin.role === '票务核销员'">
                <el-form-item label="渠道来源">
                  <el-select v-model="addAdmin.channel" placeholder="请选择渠道来源" style="width: 100%" clearable>
                    <el-option
                      v-for="(c, idx) in visitor.channelOptions"
                      :key="'channel-' + idx"
                      :label="c"
                      :value="c"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              </el-row>

              <div class="card-actions right">
                <el-button type="primary" icon="el-icon-plus" @click="onAddAdmin">添加账号</el-button>
              </div>

              <el-table :data="adminList" size="small" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', fontWeight: 700 }">
                <el-table-column label="账号" prop="username" width="160" />
                <el-table-column label="角色" prop="role" width="160" />
                <el-table-column label="供应商单位" prop="supplier" min-width="180" />
                <el-table-column label="核销地点（观礼平台）" prop="platform" min-width="200" />
                <el-table-column label="渠道来源" prop="channel" min-width="120" />
                <el-table-column label="创建时间" prop="createdAt" />
                <el-table-column label="操作" width="140" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="onResetAdminPwd(scope.row)">重置密码</el-button>
                    <el-button type="text" size="small" class="danger-text" @click="onDeleteAdmin(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-form>
        </el-card>

        <!-- 3. 游客配置设置 -->
        <el-card v-if="canEditVisitorConfig" shadow="never" class="card">
          <div slot="header" class="card-header">
            <span>游客信息配置</span>
          </div>

          <div class="sub-section-title">游客渠道选项</div>
          <el-row :gutter="16" style="margin-bottom: 10px">
            <el-col :span="20">
              <el-input v-model="visitor.channelInput" placeholder="请输入新的游客渠道" @keyup.enter.native="addChannelOption" />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="addChannelOption" style="width: 100%">添加</el-button>
            </el-col>
          </el-row>
          
          

          <el-tag
            v-for="(item, index) in visitor.channelOptions"
            :key="index"
            closable
            @close="removeChannelOption(index)"
            style="margin-right: 8px; margin-bottom: 8px"
          >
            <span style="display:inline-flex;align-items:center;gap:8px">
              {{ item }}
              <el-color-picker v-model="visitor.channelColors[item]" size="small" :predefine="[]"></el-color-picker>
            </span>
          </el-tag>

          <div class="sub-section-title" style="margin-top: 20px">票种类型选项</div>
          <el-row :gutter="16" style="margin-bottom: 10px">
            <el-col :span="20">
              <el-input v-model="visitor.ticketTypeInput" placeholder="请输入新的票种类型" @keyup.enter.native="addTicketTypeOption" />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="addTicketTypeOption" style="width: 100%">添加</el-button>
            </el-col>
          </el-row>
          <el-tag
            v-for="(item, index) in visitor.ticketTypeOptions"
            :key="index"
            closable
            @close="removeTicketTypeOption(index)"
            style="margin-right: 8px; margin-bottom: 8px"
          >
            <span style="display:inline-flex;align-items:center;gap:8px">
              {{ item }}
              <el-color-picker v-model="visitor.ticketTypeColors[item]" size="small" :predefine="[]"></el-color-picker>
            </span>
          </el-tag>

          <div class="sub-section-title" style="margin-top: 20px">入园日期选项</div>
          <el-row :gutter="16" style="margin-bottom: 10px">
            <el-col :span="20">
              <el-date-picker
                v-model="visitor.visitDateInput"
                type="date"
                placeholder="选择入园日期"
                value-format="yyyy/MM/dd"
                style="width: 100%"
              />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="addVisitDateOption" style="width: 100%">添加</el-button>
            </el-col>
          </el-row>
          <el-tag
            v-for="(item, index) in visitor.visitDates"
            :key="index"
            closable
            @close="removeVisitDateOption(index)"
            style="margin-right: 8px; margin-bottom: 8px"
          >
            {{ item }}
          </el-tag>


          <!-- 观礼平台选项与游玩区域选项已隐藏按需求 -->
          <div v-if="false">
            <div class="sub-section-title" style="margin-top: 20px">观礼平台选项</div>
            <el-row :gutter="16" style="margin-bottom: 10px">
              <el-col :span="20">
                <el-input v-model="visitor.platformInput" placeholder="请输入新的观礼平台" @keyup.enter.native="addPlatformOption" />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="addPlatformOption" style="width: 100%">添加</el-button>
              </el-col>
            </el-row>
            <el-tag
              v-for="(item, index) in visitor.platformOptions"
              :key="index"
              closable
              @close="removePlatformOption(index)"
              style="margin-right: 8px; margin-bottom: 8px"
            >
              <span style="display:inline-flex;align-items:center;gap:8px">
                {{ item }}
                <el-color-picker v-model="visitor.platformColors[item]" size="small" :predefine="[]"></el-color-picker>
              </span>
            </el-tag>

            <div class="sub-section-title" style="margin-top: 20px">游玩区域选项（按平台管理）</div>
            <el-row :gutter="16" style="margin-bottom: 10px; align-items: center">
              <el-col :span="6">
                <el-select v-model="visitor.selectedPlatformForArea" placeholder="选择平台以编辑区域" style="width: 100%">
                  <el-option v-for="(p, index) in visitor.platformOptions" :key="index" :label="p" :value="p" />
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-input v-model="visitor.areaInput" :placeholder="visitor.selectedPlatformForArea ? ('在 ' + visitor.selectedPlatformForArea + ' 下添加区域') : '请先选择平台'" @keyup.enter.native="addAreaOption" :disabled="!visitor.selectedPlatformForArea" />
              </el-col>
              <el-col :span="6">
                <el-button type="primary" @click="addAreaOption" style="width: 100%">添加</el-button>
              </el-col>
            </el-row>

            <div v-if="visitor.selectedPlatformForArea" style="margin-bottom: 8px">
              <el-tag
                v-for="(item, index) in (visitor.areaOptions[visitor.selectedPlatformForArea] || [])"
                :key="index"
                closable
                @close="removeAreaOption(visitor.selectedPlatformForArea, index)"
                style="margin-right: 8px; margin-bottom: 8px"
              >
                {{ item }}
              </el-tag>
            </div>
          </div>

          <div class="card-actions right" style="margin-top: 20px">
            <el-button type="primary" icon="el-icon-document-checked" @click="onSaveVisitorSettings">保存游客配置</el-button>
          </div>
        </el-card>

        <!-- 4. 系统信息与备份（仅超级管理员可见） -->
        <el-card v-if="isSuperAdmin" shadow="never" class="card">
          <div slot="header" class="card-header">
            <span>系统信息与备份</span>
          </div>

          <el-form :model="sys" label-width="120px" size="small">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="系统版本">
                  <el-input v-model="sys.version" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="数据库记录数">
                  <el-input v-model="sys.dbCount" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最后备份时间">
                  <el-input v-model="sys.lastBackup" disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="系统备注">
              <el-input type="textarea" :rows="4" v-model="sys.note" placeholder="请输入系统备注，例如：维护窗口、版本变更说明等" />
            </el-form-item>

            <div class="card-actions right">
              <el-button type="warning" icon="el-icon-box" @click="onBackup">备份数据库</el-button>
              <input v-if="false" ref="restoreFileInput" type="file" accept=".sql" style="display:none" @change="onRestoreFileSelected" />
              <el-button v-if="false" type="primary" icon="el-icon-upload" style="margin-left:12px" @click="$refs.restoreFileInput.click()">导入恢复文件</el-button>
            </div>
          </el-form>
        </el-card>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppSidebar from '../../components/AppSidebar.vue'
import { getAdmins, createAdmin, resetAdminPassword, deleteAdmin, changePassword, getSystemStats, backupDatabase, getSettings, saveVisitorSettings, restoreDatabase } from '../../api'
import { PLATFORMS } from '../../config/platforms'
import { API_BASE } from '../../api/http'
import { downloadByUrl } from '../../utils/download'

export default {
  name: 'SystemSettingsPage',
  components: { AppSidebar },
  data() {
    return {
      activeMenu: '6',
      // 核销地点（观礼平台）下拉选项：按需求写死
      platformOptions: PLATFORMS.slice(),
      db: {
        host: 'localhost',
        port: '3306',
        database: '',
        username: '',
        password: '',
        charset: 'utf8mb4'
      },
      admin: {
        username: 'admin',
        loginAt: '2026/01/07 23:41:06',
        role: '超级管理员',
        supplier: ''
      },
      pwd: {
        old: '',
        new: '',
        confirm: ''
      },
      addAdmin: {
        username: '',
        password: '',
        role: '游客录入员',
        supplier: '',
        platform: '',
        channel: ''
      },
      adminList: [],
      sys: {
        version: '2.1.0',
        dbCount: '0',
        lastBackup: '无备份记录',
        lastBackupFile: '',
        note: '请在数据库配置正确后，定期备份系统数据。'
      },
        visitor: {
        channelOptions: [],
        ticketTypeOptions: [],
        platformOptions: [],
        // supplierOptions removed (not part of visitor config)
        // areaOptions stored as mapping: { platformName: [area1, area2] }
        areaOptions: {},
        // color mappings: { optionName: '#rrggbb' }
        ticketTypeColors: {},
        channelColors: {},
        platformColors: {},
        // 入园日期列表（字符串）
        visitDates: [],
        channelInput: '',
        // supplierInput removed
        ticketTypeInput: '',
        platformInput: '',
        areaInput: '',
        visitDateInput: '',
        selectedPlatformForArea: ''
      }
    }
  },
  computed: {
    isSuperAdmin() {
      return (this.admin && this.admin.role) === '超级管理员'
    }
    ,
    // 只有超级管理员可以看到并编辑游客信息配置
    canEditVisitorConfig() {
      const role = this.admin && this.admin.role
      return role === '超级管理员'
    }
  },
  created() {
    this.loadCurrentAdmin()
    this.loadAdmins()
    this.loadSystemStats()
    this.loadSettings()
  },
  methods: {
    loadCurrentAdmin() {
      const AUTH_KEY = 'yy_auth'
      try {
        const raw = localStorage.getItem(AUTH_KEY)
        const auth = raw ? JSON.parse(raw) : null
        const user = auth && auth.user ? auth.user : null

        this.admin.username = (user && user.username) || ''
        this.admin.role = (user && user.role) || ''
        this.admin.supplier = (user && user.supplier) || ''
        // 若是票务核销员，则从登录信息中读取其核销地点（观礼平台）
        if (this.admin.role === '票务核销员') {
          this.admin.platform = (user && user.platform) || ''
        }
        this.admin.loginAt = auth && auth.loginAt ? new Date(auth.loginAt).toLocaleString() : ''
      } catch (e) {
        // ignore
      }
    },
    // 将日期字符串数组按时间升序排序，接受 yyyy/MM/dd 或 yyyy-MM-dd 等格式
    sortVisitDates(dates) {
      if (!dates || !Array.isArray(dates)) return []
      const arr = dates.slice().filter(d => !!d)
      arr.sort((a, b) => {
        const pa = String(a).replace(/\//g, '-')
        const pb = String(b).replace(/\//g, '-')
        const da = new Date(pa)
        const db = new Date(pb)
        return da - db
      })
      return arr
    },
    async loadAdmins() {
      if (!this.isSuperAdmin) {
        this.adminList = []
        return
      }
      try {
        const data = await getAdmins()
        this.adminList = (data.list || []).map(r => ({
          ...r,
          platform: r.platform || '',
          channel: r.channel || ''
        }))
      } catch (e) {
        // 非超级管理员会被后端拒绝，这里静默即可
        this.adminList = []
      }
    },
    async loadSystemStats() {
      try {
        const data = await getSystemStats()
        this.sys.dbCount = String(data.dbCount ?? '')
        this.sys.lastBackup = data.lastBackup || '无备份记录'
        this.sys.lastBackupFile = data.lastBackupFile || ''
      } catch (e) {
        this.$message.error(e.message || '加载系统信息失败')
      }
    },
    onSwitchAccount() {
      const AUTH_KEY = 'yy_auth'
      try {
        localStorage.removeItem(AUTH_KEY)
      } catch (e) {
        // ignore
      }
      const redirect = this.$route ? this.$route.fullPath : '/'
      this.$router.replace({ path: '/login', query: { redirect } })
    },
    onSaveAll() {
      this.$message.success('已保存（示例）')
    },
    onLoadDbDefault() {
      this.db = {
        host: 'localhost',
        port: '3306',
        database: '',
        username: '',
        password: '',
        charset: 'utf8mb4'
      }
    },
    onTestDb() {
      this.$message.success('测试连接成功（示例）')
    },
    onSaveDb() {
      this.$message.success('数据库配置已保存（示例）')
    },
    async onChangePassword() {
      if (!this.pwd.old || !this.pwd.new || !this.pwd.confirm) {
        this.$message.warning('请填写完整密码信息')
        return
      }
      if (this.pwd.new !== this.pwd.confirm) {
        this.$message.error('两次输入的新密码不一致')
        return
      }

      try {
        await changePassword({
          oldPassword: this.pwd.old,
          newPassword: this.pwd.new
        })
        this.$message.success('密码修改成功')
        this.pwd = { old: '', new: '', confirm: '' }
      } catch (e) {
        this.$message.error(e.message || '修改密码失败')
      }
    },
    async onAddAdmin() {
      if (!this.addAdmin.username || !this.addAdmin.password) {
        this.$message.warning('请填写账号和初始密码')
        return
      }

      try {
        await createAdmin({
          username: this.addAdmin.username,
          password: this.addAdmin.password,
          role: this.addAdmin.role,
          supplier: this.addAdmin.supplier || '',
          platform: this.addAdmin.role === '票务核销员' ? (this.addAdmin.platform || '') : '',
          channel: this.addAdmin.role === '票务核销员' ? (this.addAdmin.channel || '') : ''
        })
        this.$message.success('已添加管理员')
        this.addAdmin = { username: '', password: '', role: '游客录入员', supplier: '', platform: '', channel: '' }
        await this.loadAdmins()
      } catch (e) {
        // 如果后端返回未登录（例如 token 过期或缺失），提示并跳转到登录页
        if (e && (e.message === '未登录' || e.code === 401)) {
          this.$message.error('未登录或登录已超时，请先登录')
          // 带上当前路径，登录后可重定向回来
          this.$router.replace({ path: '/login', query: { redirect: this.$route.fullPath } })
          return
        }
        this.$message.error(e.message || '添加管理员失败')
      }
    },
    async onResetAdminPwd(row) {
      const { value } = await this.$prompt(`请输入账号 ${row.username} 的新密码`, '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: v => !!v && v.length >= 6,
        inputErrorMessage: '密码至少需要6位'
      }).catch(() => ({ value: null }))

      if (value === null) return

      try {
        await resetAdminPassword(row.id, value)
        this.$message.success('已重置密码')
      } catch (e) {
        this.$message.error(e.message || '重置密码失败')
      }
    },
    async onDeleteAdmin(row) {
      await this.$confirm(`确认删除管理员账号 ${row.username}？`, '提示', { type: 'warning' }).catch(() => null)

      try {
        await deleteAdmin(row.id)
        this.$message.success('已删除')
        await this.loadAdmins()
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    },
    async onBackup() {
      try {
        const data = await backupDatabase()
        this.$message.success('备份成功')
        this.sys.lastBackup = data.createdAt || new Date().toLocaleString()
        this.sys.lastBackupFile = data.filename || ''
        await this.loadSystemStats()
        // 自动触发下载备份文件（如果后端返回了文件名）
        if (data && data.filename) {
          try {
            this.onDownloadBackup()
          } catch (e) {
            // ignore download errors
          }
        }
      } catch (e) {
        this.$message.error(e.message || '备份失败')
      }
    },
    onDownloadBackup() {
      const file = this.sys.lastBackupFile
      if (!file) {
        this.$message.warning('暂无可导出的备份文件，请先备份数据库')
        return
      }
      const url = `${API_BASE}/api/system/backup/download?file=${encodeURIComponent(file)}`
      downloadByUrl(url)
    },
    async onRestoreFileSelected(e) {
      const files = e.target.files || e.dataTransfer && e.dataTransfer.files
      if (!files || files.length === 0) return
      const file = files[0]
      if (!file.name || !file.name.toLowerCase().endsWith('.sql')) {
        this.$message.warning('请选择 .sql 文件')
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      try {
        this.$message.info('正在上传并恢复数据库，请稍候...')
        await restoreDatabase(formData)
        this.$message.success('数据库已恢复')
        await this.loadSystemStats()
      } catch (err) {
        this.$message.error(err.message || '恢复失败')
      } finally {
        // clear file input
        if (this.$refs && this.$refs.restoreFileInput) {
          this.$refs.restoreFileInput.value = ''
        }
      }
    },
    async loadSettings() {
      try {
        const data = await getSettings()
        console.log('LOAD settings response visitor:', data && data.visitor)
        if (data.visitor) {
          this.visitor.channelOptions = data.visitor.channelOptions || []
          this.visitor.ticketTypeOptions = data.visitor.ticketTypeOptions || []
          // 平台固定为代码中的常量，不使用后端配置
          this.visitor.platformOptions = PLATFORMS.slice()
          // colors: may be mapping object or array, convert to object format
          this.visitor.ticketTypeColors = this.convertColorsToObject(data.visitor.ticketTypeColors, this.visitor.ticketTypeOptions)
          this.visitor.channelColors = this.convertColorsToObject(data.visitor.channelColors, this.visitor.channelOptions)
          this.visitor.platformColors = this.convertColorsToObject(data.visitor.platformColors, this.visitor.platformOptions)
          // 保留后端返回的所有日期（不过滤），新添加的日期追加到老日期里
          this.visitor.visitDates = this.sortVisitDates(data.visitor.visitDates || [])
          // Merge admin-provided supplier strings into channelOptions if present (treat them as channels)
          let adminSuppliers = []
          try {
            const adminsResp = await getAdmins()
            const admins = adminsResp && Array.isArray(adminsResp.list) ? adminsResp.list : []
            adminSuppliers = Array.from(new Set(admins.map(a => (a && a.supplier) ? String(a.supplier).trim() : '').filter(Boolean)))
          } catch (e) {
            adminSuppliers = []
          }
          this.visitor.channelOptions = Array.from(new Set([...(this.visitor.channelOptions || []), ...adminSuppliers]))
          // areaOptions may be an array (old format) or mapping object (new)
          const ao = data.visitor.areaOptions
          console.log('RAW areaOptions from server:', ao)
          if (ao && Array.isArray(ao)) {
            // convert to mapping: assign same areas to all platforms
            const map = {};
            (this.visitor.platformOptions || []).forEach(p => {
              map[p] = ao.slice()
            })
            this.visitor.areaOptions = map
          } else if (ao && typeof ao === 'object') {
            this.visitor.areaOptions = ao
          } else {
            this.visitor.areaOptions = {}
          }
          // choose default selected platform
          this.visitor.selectedPlatformForArea = this.visitor.platformOptions[0] || ''
        }
      } catch (e) {
        this.$message.error(e.message || '加载设置失败')
      }
    },
    addChannelOption() {
      const value = this.visitor.channelInput.trim()
      if (!value) return
      if (this.visitor.channelOptions.includes(value)) {
        this.$message.warning('该选项已存在')
        return
      }
      this.visitor.channelOptions.push(value)
      // 默认颜色
      this.$set(this.visitor.channelColors, value, '#409EFF')
      this.visitor.channelInput = ''
    },
    
    removeChannelOption(index) {
      const v = this.visitor.channelOptions[index]
      this.visitor.channelOptions.splice(index, 1)
      if (v && this.visitor.channelColors && this.visitor.channelColors[v]) {
        this.$delete(this.visitor.channelColors, v)
      }
    },
    addTicketTypeOption() {
      const value = this.visitor.ticketTypeInput.trim()
      if (!value) return
      if (this.visitor.ticketTypeOptions.includes(value)) {
        this.$message.warning('该选项已存在')
        return
      }
      this.visitor.ticketTypeOptions.push(value)
      // 默认颜色
      this.$set(this.visitor.ticketTypeColors, value, '#409EFF')
      this.visitor.ticketTypeInput = ''
    },
    removeTicketTypeOption(index) {
      const v = this.visitor.ticketTypeOptions[index]
      this.visitor.ticketTypeOptions.splice(index, 1)
      if (v && this.visitor.ticketTypeColors && this.visitor.ticketTypeColors[v]) {
        this.$delete(this.visitor.ticketTypeColors, v)
      }
    },
    addVisitDateOption() {
      const v = (this.visitor.visitDateInput || '').trim()
      if (!v) return
      // 验证日期不能是过去的日期
      try {
        const dateStr = v.replace(/\//g, '-')
        const dateObj = new Date(dateStr)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        if (isNaN(dateObj.getTime())) {
          this.$message.warning('日期格式不正确')
          return
        }
        if (dateObj < today) {
          this.$message.warning('不能添加过去的日期')
          return
        }
      } catch (e) {
        this.$message.warning('日期格式不正确')
        return
      }
      if (this.visitor.visitDates.includes(v)) {
        this.$message.warning('该日期已存在')
        return
      }
      // 直接追加到列表，保留后端返回的所有日期
      this.visitor.visitDates.push(v)
      this.visitor.visitDates = this.sortVisitDates(this.visitor.visitDates)
      this.visitor.visitDateInput = ''
    },
    removeVisitDateOption(index) {
      this.visitor.visitDates.splice(index, 1)
    },
    addPlatformOption() {
      const value = this.visitor.platformInput.trim()
      if (!value) return
      if (this.visitor.platformOptions.includes(value)) {
        this.$message.warning('该选项已存在')
        return
      }
      this.visitor.platformOptions.push(value)
      // create empty area list for this platform
      this.$set(this.visitor.areaOptions, value, [])
      this.visitor.platformInput = ''
      // auto-select it for editing areas
      this.visitor.selectedPlatformForArea = value
      // default platform color
      this.$set(this.visitor.platformColors, value, '#409EFF')
    },
    removePlatformOption(index) {
      const p = this.visitor.platformOptions[index]
      this.visitor.platformOptions.splice(index, 1)
      if (p && this.visitor.areaOptions && this.visitor.areaOptions[p]) {
        this.$delete(this.visitor.areaOptions, p)
      }
      if (this.visitor.selectedPlatformForArea === p) {
        this.visitor.selectedPlatformForArea = this.visitor.platformOptions[0] || ''
      }
      if (p && this.visitor.platformColors && this.visitor.platformColors[p]) {
        this.$delete(this.visitor.platformColors, p)
      }
    },
    addAreaOption() {
      const platform = this.visitor.selectedPlatformForArea
      if (!platform) {
        this.$message.warning('请先选择平台')
        return
      }
      const value = this.visitor.areaInput.trim()
      if (!value) return
      // debug: log current platform, input and existing areas
      console.log('addAreaOption -> platform:', platform, 'value:', value, 'existing:', this.visitor.areaOptions[platform])

      // ensure we operate on a fresh array reference to trigger reactivity reliably
      const existing = Array.isArray(this.visitor.areaOptions[platform]) ? this.visitor.areaOptions[platform].slice() : []
      if (existing.includes(value)) {
        this.$message.warning('该选项已存在')
        return
      }
      existing.push(value)
      // set a new array reference
      this.$set(this.visitor.areaOptions, platform, existing)
      this.visitor.areaInput = ''
    },
    removeAreaOption(platform, index) {
      const arr = this.visitor.areaOptions[platform] || []
      arr.splice(index, 1)
      this.$set(this.visitor.areaOptions, platform, arr)
    },

    // 转换颜色数据为对象格式 {optionName: '#color'}
    convertColorsToObject(colors, options) {
      if (!colors) return {}

      // 如果已经是对象格式，直接返回
      if (typeof colors === 'object' && !Array.isArray(colors)) {
        return colors
      }

      // 如果是数组格式，转换为对象格式
      if (Array.isArray(colors)) {
        const result = {}
        // 为每个选项分配颜色，如果数组中有对应的颜色就用，否则用默认颜色
        options.forEach((option, index) => {
          result[option] = colors[index] || '#409EFF'
        })
        return result
      }

      return {}
    },
    async onSaveVisitorSettings() {
      try {
        const payload = {
          channelOptions: this.visitor.channelOptions,
          ticketTypeOptions: this.visitor.ticketTypeOptions,
          platformOptions: this.visitor.platformOptions,
          areaOptions: this.visitor.areaOptions,
          ticketTypeColors: this.visitor.ticketTypeColors,
          channelColors: this.visitor.channelColors,
          platformColors: this.visitor.platformColors,
          // 保存完整日期列表（不过滤）
          visitDates: this.sortVisitDates(this.visitor.visitDates)
        }
        // debug: print payload before sending
        console.log('SAVE visitor settings payload:', payload)
        const res = await saveVisitorSettings(payload)
        console.log('SAVE visitor settings response:', res)
        // reload settings so the page reflects saved colors/options immediately
        await this.loadSettings()
        this.$message.success('游客配置已保存')
      } catch (e) {
        this.$message.error(e.message || '保存游客配置失败')
      }
    }
  }
}
</script>

<style scoped>
.page {
  height: 100vh;
  background: #f5f7fa;
}

.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #303133;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
}

.main {
  padding: 16px;
}

.card {
  margin-bottom: 16px;
}

.card-header {
  font-weight: 700;
  color: #303133;
}

.sub-section-title {
  margin: 8px 0 12px;
  font-weight: 700;
  color: #606266;
}

.card-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 6px;
}

.card-actions.right {
  justify-content: flex-end;
}

.danger-text {
  color: #f56c6c;
}
</style>

